export default __webpack_public_path__ + "static/swayaan-b1d325120bb65a200624319c3b55fadf.png";